import { Box, Paper, Stack, Tooltip, Typography } from "@mui/material";
import Icon from "@mui/material/Icon";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import { useTranslation } from "react-i18next";
import { DECORATION_CATALOG, DECORATION_DRAG_MIME } from "../../utils/decorationCatalog";
import type { DashboardDecorationKind } from "../../types/dashboard";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

type Props = {
  onAddDecoration: (kind: DashboardDecorationKind) => void;
};

export default function DecorationPalette({ onAddDecoration }: Props) {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();
  const styles = custom.components.decorationPalette;

  return (
    <Box sx={styles.list}>
      {DECORATION_CATALOG.map((entry) => {
        const label = t(entry.labelKey);
        const description = t(entry.descriptionKey);
        return (
          <Tooltip
            key={entry.kind}
            title={
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.25 }}>
                  {label}
                </Typography>
                <Typography variant="caption">{description}</Typography>
              </Box>
            }
            placement="top"
            enterDelay={300}
          >
            <Paper
              variant="outlined"
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData(DECORATION_DRAG_MIME, entry.kind);
                e.dataTransfer.effectAllowed = "copy";
              }}
              onDoubleClick={() => onAddDecoration(entry.kind)}
              sx={styles.item}
            >
              <Icon fontSize="small" color="secondary" sx={styles.kindIcon}>
                {entry.icon}
              </Icon>
              <Typography variant="caption" sx={styles.itemLabel}>
                {label}
              </Typography>
            </Paper>
          </Tooltip>
        );
      })}
    </Box>
  );
}

export function DecorationPaletteHeader() {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={custom.components.decorationPalette.header}>
      <DesignServicesOutlinedIcon fontSize="small" color="secondary" />
      <Typography variant="subtitle2" fontWeight={700} noWrap>
        {t("dashboard.decor.palette")}
      </Typography>
    </Stack>
  );
}
